import React from 'react';
import PropTypes from 'prop-types';

const ButtonSecondary = ({ children, isDisabled = false, className = '', ...props }) => {
    return (
        <button
            className={`
                px-3 py-2 text-xs font-semibold text-primary rounded-t rounded-b bg-white border border-primary
                ${isDisabled ? 'opacity-50' : 'hover:outline-none hover:bg-platinum focus:outline-none focus:bg-grayX11'}
                ${className}
            `}
            disabled={isDisabled}
            {...props}
        >
            {children}
        </button>
    );
};

ButtonSecondary.propTypes = {
    children: PropTypes.node.isRequired,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
};

export default ButtonSecondary;
